import { Capacitor } from "@capacitor/core";
import { useContext } from "react";
import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { WidgetContext } from "src/contexts/WidgetContext";
import { isMobileWebBrowser } from "src/utils/platformUtils";
import { getIsPollingRequest } from "src/utils/pollingContext";

export const analyzeTrade = async (
  userId: string,
  leagueId: string,
  give: {},
  receive: {},
  swid: string,
  espn_s2: string,
  teamsTrade,
  currentUserDataPlatform,
  pocToken,
  accessAuthToken,
  yahooToken,
  commonLeagueLeagueType: string,
  signal?: AbortSignal,
  competitorTeamId?: string,
  competitorOwnerId?: string,
  audioSettings?: boolean,
  calculatorSettings?: any,
  model?: "RotoGPT 5.0" | "RotoGPT FREE",
  analyticsAuthId?: string
): Promise<Response | string | undefined> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/analyze_fantasy_league_trade_streaming`;
    console.log("teamsTrade", teamsTrade);
    // Function to trasnform team_format: if superflex is true, render 'sf'. If standard is true then render 'standard', if 2QB is true then render '2QB'
    const TeamFormat = () => {
      if (teamsTrade.league_info.settings.superflex) {
        return "sf";
      } else if (teamsTrade.league_info.settings["2QB"]) {
        return "2QB";
      } else if (teamsTrade.league_info.settings.standard) {
        return "standard";
      }
      return "standard";
    };

    //Function to convert te_premium: If te_premium is false, render 0 and if true 1
    const TePremium = () => {
      return teamsTrade.league_info.settings.TE_Premium ? 1 : 0;
    };

    const requestData: any = {
      model: model || "RotoGPT 5.0",
      sport: "NFL",
      // client_id: "roto",
      pocToken: pocToken,
      // token: userDataPlatform.token,
      league_integration: {
        integration_name: currentUserDataPlatform.integration_name,
        // token: token.accessToken || null,
        league_id: leagueId?.toString(),
        user_id: userId || "",
        leagueToken: currentUserDataPlatform.integration_name === "yahoo" ? yahooToken : currentUserDataPlatform.token, //I added it in this way, because the token below I mean from league_settings.token must be null otherwise in MFL this endpoint it fails. In sleeper it works but not in mfl
      },
      response_settings: {
        persona_input: "lombard_ai",
        // max_words: 0,
        response_type: "markdown",
        audio_settings: audioSettings,
      },

      //if calculatorSettings is provided (save changes in the league settings), use it, otherwise use the default values
      calculator_settings: calculatorSettings || {
        team_format: TeamFormat().toLowerCase(),
        // team_type: "ppr",
        team_type: teamsTrade.league_info.league_format.toLowerCase().toString(),
        team_size: teamsTrade.league_info.league_size.toString(), //convert to string
        // teamm_size:"12",
        te_premium: TePremium(),
        rb_premium: 0,
        league_type: commonLeagueLeagueType.toString().toLowerCase(), //before it was dynasty like harcoded, now it is commonLeagueLeagueType
        // devy: 0,
        offense: 1,
        idp: 1,
        // mode: "normal",
        // startup_rookie: "no",
      },

      // ...(calculatorSettings && { calculator_settings: calculatorSettings }),
      // // league_settings: {
      // calculator_settings: {
      //   team_format: TeamFormat().toLowerCase(),
      //   // team_type: "ppr",
      //   team_type: teamsTrade.league_info.league_format.toLowerCase().toString(),
      //   team_size: teamsTrade.league_info.league_size.toString(), //convert to string
      //   // teamm_size:"12",
      //   te_premium: TePremium(),
      //   rb_premium: 0,
      //   league_type: commonLeagueLeagueType.toString().toLowerCase(), //before it was dynasty like harcoded, now it is commonLeagueLeagueType
      //   // devy: 0,
      //   offense: 1,
      //   idp: 1,
      //   // mode: "normal",
      //   // startup_rookie: "no",
      // },

      give: give,
      receive: receive,
      // NEW: for cache key
      cache_metadata: {
        competitor_team_id: competitorTeamId,
        competitor_owner_id: competitorOwnerId,
      },
    };

    // If the platform is ESPN, add the specific fields it requires
    if (currentUserDataPlatform.integration_name === "espn") {
      requestData.league_integration.swid = swid;
      requestData.league_integration.espn_s2 = espn_s2;
    }

    // console.log("THIS IS REQUESTADATA ANALYZE", requestData);
    console.log("analyzeTrade response_settings", requestData);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
        Connection: "keep-alive", // Fuerza HTTP/2
        "Alt-Svc": "clear", // Fuerza HTTP/2
        ...(getIsPollingRequest() && { "X-Polling-Request": "true" }),
      },
      body: JSON.stringify(requestData),
      signal,
      credentials: "include",
    });

    if (!response.ok) {
      // Detect rate limit before reading body
      if (response.status === 429) {
        const err = new Error("TOO_MANY_REQUESTS") as any;
        err.isRateLimit = true;
        const data429 = await response.json().catch(() => ({}));
        err.retryAfter = data429?.retryAfter ?? 60;
        throw err;
      }

      // const errorData = await response.json();
      // const errorMessage = errorData.detail || errorData.message;
      // throw new Error(errorMessage);

      const errorData = await response.json();
      let errorMessage;

      // if the error is an array, then get the first error message
      if (Array.isArray(errorData.detail)) {
        errorMessage = errorData.detail[0].msg;
      } else {
        // if the error is not an array, then get the error message
        errorMessage = errorData.detail || errorData.message;
      }

      throw new Error(errorMessage);
            // add a flag to the error to indicate that it came from the initial request
      // const err = new Error(errorMessage) as Error & { fromInitialRequest?: boolean };
      // err.fromInitialRequest = true;
      // throw err;
    }

    // Check if response is JSON (INCOMPLETE) or Stream
    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      const jsonData = await response.json();
      if (jsonData.status === "INCOMPLETE") {
        return "INCOMPLETE"; // Special return value for polling detection
      }
    }

    // const data = await response.json();
    // console.log("THIS IS ANALYZE TRADE DATA", data);

    // return data;
    // console.log("THIS IS ANALYZE TRADE RESPONSE", response);
    return response;
  } catch (error) {
    //   if (error.name === "AbortError") {
    //     // Handle abort silently
    //     console.log("Analyze trade request was aborted");
    //     // return null; // This will stop the execution of the function (no error message in ui)
    //     return; // Return undefined to stop execution
    //   }

    //   showErrorToast(error.message);
    //   throw error;
    // }

    if (error.name === "AbortError") {
      // Let the caller know it was intentionally aborted.
      throw error;
      // } else if (Capacitor.isNativePlatform() || isMobileWebBrowser() || error.name === "TypeError") {
    }
    // Rate limit errors must never fall back to polling
    if ((error as any).isRateLimit) throw error;

    // Initial request returned 4xx/5xx: show Retry in UI, do not fall back to polling
    // if ((error as Error & { fromInitialRequest?: boolean }).fromInitialRequest) {
    //   throw error;
    // }
     if (Capacitor.isNativePlatform() || isMobileWebBrowser() || error.name === "TypeError") {
      // On native platforms, or for network errors on web (TypeError),
      // we gracefully fall back to polling, UNLESS it's a "no draft" error.
      if (error.message && error.message.includes("Rosters are empty")) {
        console.error("[analyzeTrade] Detected 'Rosters are empty' on native. Re-throwing error.", error);
        throw error; // Let HomePage handle this as a final error.
      }
      console.warn(`analyzeTrade stream error (type: ${error.name}), falling back to polling:`, error);
      return "INCOMPLETE"; // Signal to the UI to start polling for completion.
    } else {
      // For any other type of error, re-throw it to be handled by the component.
      console.error("Error in analyzeTrade API call:", error);
      showErrorToast(error.message);
      throw error;
    }
  }
};
